//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "my-delivery",
  data() {
    return {
      wrapperHeight: 0,
      allLoaded: false,
      statusList: [{name:'全部',code:null},{name:'待接单',code:'WAITING_ORDER'},{name:'发运中',code:'DELIVERY'},{name:'预约卸货',code:'BOOKING'},{name:'已完成',code:'FINISH'}],
      orderList: [],
      rulesObj:{
        'shipMethod':{
          field: "shipMethod",
          option:'IN',
          values:['SELF_DELIVER','LOGISTICS']
        }
      },
      pageRules:{
        direction: "DESC",
        fromClientType: "h5",
        number: 0,
        property: "createdDate",
        size:10,
        rules:[],
        specialConditions: []
      },
      carNumberShow:false,
      driver:{}
    }
  },
  methods: {
    clear(){
      delete this.rulesObj.search;
      this.getOrderList()
    },
    onCheckerClick(e){
      if(e){
        this.rulesObj.itemStatus = {field:"driStatus",option:'EQ',values:[e]};
      }else{
        delete this.rulesObj.itemStatus
      }
      this.getOrderList();
    },
    goDetail(order){
      this.$router.push(`/driver/delivery-detail/${order.id}`);
    },
    init: function () {
      this.wrapperHeight =document.documentElement.clientHeight - this.$refs.wrapper.getBoundingClientRect().top;
    },
    //点击搜索按钮
    searchOrder(searchData){
      this.rulesObj.search={field:"orderNo",collectIndex:-1,option: "LIKE_ANYWHERE",values:[searchData['key']]},
        this.getOrderList();
    },
    loadTop() {
      this.pageRules.number = 0;
      this.$post('/api/asn/page',this.pageRules).then((list) => {
        this.orderList = list.content;
        this.$refs.loadmore.onTopLoaded();
      }).catch(() => {
        this.$refs.loadmore.onTopLoaded();
      });
    },
    loadBottom() {
      this.pageRules.number++;
      this.$post('/api/asn/page',this.pageRules).then((list) => {
        this.orderList = this.orderList.concat(list.content);
        if(list.length<10){
          this.$vux.toast.text('已经加载全部');
        }
        this.$refs.loadmore.onBottomLoaded();
      }).catch(() => {
        this.$refs.loadmore.onBottomLoaded();
      });
    },
    getOrderList(){
      this.$loadingShow();
      this.pageRules.number = 0;
      this.pageRules.rules=Object.values(this.rulesObj).filter(val=>val.field && val.values[0]);
      this.$post('/api/asn/page',this.pageRules).then((list) => {
        this.orderList = list.content;
        this.$loadingHide();
      }).catch((error) => {
        this.$loadingHide();
      });
    },
    onShow(){
      this.$refs.carNumber.setInputValue(this.driver.carNumber);
    },
    onConfirm(e){
      this.driver.carNumber = e;
      this.driver.firstLogin = true;
      this.$loadingShow();
      this.$put('api/driver',this.driver).then(() => {
        this.$vux.toast.text('确认成功');
        this.$loadingHide();
      }).catch(() => {
        this.$loadingHide();
      })
    }
  },
  mounted() {
    this.init();
    this.$loadingShow();
    this.$get('api/person/current').then((val) => {
      this.$get(`api/driver/tel/${val.login}`).then((res) => {
        if(res){
          this.driver = res;
          if(!res.driverIds){
            res.driverIds = [];
          }
          this.rulesObj['carrierId'] = {
            field:'carrierId',
            option:'IN',
            values:res.driverIds
          };
          if(!res.firstLogin){
            this.carNumberShow = true;
            console.log(res.carNumber);
          }
        }
        this.$loadingHide();
        this.onCheckerClick('WAITING_ORDER');
      }).catch(() => {
        this.$loadingHide();
        this.$vux.toast.text('当前登录人员不是司机');
      })
    }).catch(() => {
      this.$loadingHide();
    });
  }
}



// WEBPACK FOOTER //
// ./src/page/driver/my-delivery.vue